import React from 'react'

import { Spinner } from '@vtex/shoreline'
import { t } from 'i18next'

import styles from './styles.module.css'

export interface ChartBoxProps {
  loading: boolean
  refreshing?: boolean
  children: React.ReactNode
}

const ChartBox = ({ loading, refreshing, children }: ChartBoxProps) => (
  <div className={styles.wrapper}>
    {loading ? (
      <div className={styles.loader}>
        <Spinner size={48} />
        <span>{t('rm:spendReport.loadingData')}</span>
      </div>
    ) : (
      <div className={styles.content}>
        {refreshing && (
          <div className={styles.overlay}>
            <Spinner size={32} />
          </div>
        )}
        {children}
      </div>
    )}
  </div>
)

export default ChartBox
